import React, { useEffect, useState } from "react";
import RentPropImg from "../../assets/images/icons/rent-icon.svg";
import { Search } from "react-feather";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import PopertyLocationSearch from "../common/property-location-search";
import propertyService from "../../services/propertyService";
import buymoduleService from "../../services/BuyModule-service/buy-module-service";
import bannerElement from "../../assets/images/banner-element.png";

//new dropdown design
import PropertyTypeSelect from "../common/PropertyTypeSelect";

const Banner = ({
  classname = "",
  heading = "FLATS AND APARTMENTS FOR RENT IN BANGALORE",
  subheading = (
    <>
      Browse 1BHK and 2BHK ready-to-move flats across Bangalore. <br /> No
      hidden charges. Just the right home for you.
    </>
  ),
}) => {
  const navigate = useNavigate();

  //this filter is for rent module page
  const [formValues, setFormValues] = useState({
    stayType: 0,
    propertyType: 0,
    location: "",
  });

  //this state is for buy module filter
  const [seletedFilter, setSelectedFilter] = useState({
    type: "",
    bhk: "",
    propertyType: "",
    status: "",
    search: "",
  });

  const buyFilterUpdate = (key, value) => {
    setSelectedFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const [searchParams, setSearchParams] = useSearchParams();

  const isAnyfilterSet = () => {
    if (!seletedFilter || typeof seletedFilter !== "object") return false;

    //here we are checking if user select the filter or not . and we are not want to take laction as a filter.
    //so if key name is search then dont show the selected filter box.
    return Object.entries(seletedFilter).some(
      ([key, value]) => value !== "" && value !== null && key !== "search",
    );
  };

  const seletedFilterArray = Object.entries(seletedFilter).map(
    ([key, value]) => ({
      key,
      value,
    }),
  );

  // this is used to clear the filter
  const clearSelectedfilters = (key, value) => {
    setSelectedFilter((prev) => ({
      ...prev,
      [key]: "",
    }));
  };
  //this is the end of buy module filter logic

  const [bhkTypes, setBhkTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [locations, setLocations] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(true);
  const [bhkError, setBhkError] = useState(null);
  const [locationError, setLocationError] = useState(null);

  // this state is used to check in module page we are in
  const [isBuyModulePage, setIsBuyModulePage] = useState(false);
  // Fetch BHK types from the service
  useEffect(() => {
    const fetchBhkTypes = async () => {
      try {
        const response = await propertyService.getBhkTypes();

        if (response.data.isSuccess) {
          setBhkTypes(response.data.result);
        } else {
          setBhkError("No BHK Type Found");
        }
      } catch (error) {
        setBhkError("No BHK Type Found");
      } finally {
        setLoading(false);
      }
    };

    fetchBhkTypes();
  }, []);

  useEffect(() => {
    const fetchAllLocations = async () => {
      let response;
      try {
        //here based on the page where we are based on that we are calling respective api
        if (!isBuyModulePage) {
          response = await propertyService.getPropertyLocations();
        } else {
          response = await buymoduleService.allLocations();
        }

        const allLocations = response.data?.result || [];
        if (Array.isArray(allLocations)) {
          setAllLocations(allLocations.map((item) => item.locationName));
          setLocations(allLocations.map((item) => item.locationName));
        } else {
          setLocations([]);
        }
      } catch (error) {
        setLocations([]);
        setLocationError("Error fetching locations.");
      }
    };

    fetchAllLocations();
  }, [isBuyModulePage]);

  const fetchLocationSuggestions = async (value) => {
    if (value.trim() === "") {
      setLocations([]);
      return;
    }
    setIsLoading(true);
    let response;
    try {
      if (!isBuyModulePage) {
        //if not buy page then call this ApI
        const payload = {
          locName: value,
        };
        response = await propertyService.getLocationSuggestions(payload);
      } else {
        response = await buymoduleService.searchlocationSuggestions(value);
      }

      const locationsres = response.data.result || [];
      setLocations(locationsres.map((item) => item.locationName));
    } catch (error) {
      setLocationError("No Locations Found");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (formValues.location) {
      fetchLocationSuggestions(formValues.location);
    }
  }, [formValues.location]);

  const handleInputChange = (value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      location: value,
    }));

    //when user types and location on that time update the location
    // this is for  buy module filter above is rent module func
    setSelectedFilter((prev) => ({
      ...prev,
      search: value,
    }));

    if (!value) {
      setLocations((prevValues) => [...allLocations]);
    }
  };

  const handleSubmit = () => {
    // e.preventDefault();
    // const validationErrors = validateBannerForm(formValues);
    // setErrors(validationErrors);
    // here we are checking if we are not in buy module page then only we will navigate to properties page
    // with query params otherwise we will stay in buy module page and apply filters there

    if (!isBuyModulePage) {
      const selectedPropertyType =
        bhkTypes.find((type) => type.bhkType === formValues.propertyType)
          ?.bhkType || "";
      let qryParam = {};
      if (formValues.location !== "" && selectedPropertyType !== "") {
        qryParam = {
          location: formValues.location,
          bhkType: selectedPropertyType,
        };
        const queryParams = new URLSearchParams(qryParam).toString();
        navigate(`/properties?${queryParams}`);
      } else if (selectedPropertyType !== "") {
        qryParam = {
          bhkType: selectedPropertyType,
        };

        const queryParams = new URLSearchParams(qryParam).toString();
        navigate(`/properties?${queryParams}`);
      } else if (formValues.location !== "") {
        qryParam = {
          location: formValues.location,
        };
        const queryParams = new URLSearchParams(qryParam).toString();
        navigate(`/properties?${queryParams}`);
      } else {
        navigate(`/properties`);
      }
    }

    // if we are in buy  module page then the update of query params will be handled like this
    else {
      const params = new URLSearchParams();
      Object.entries(seletedFilter).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
        if (params) {
          navigate(`/buy/list?${params}`);
        } else {
          navigate("/buy/list");
        }
      });
    }
  };

  const handleSuggestionClick = (value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      location: value,
    }));

    //when user clicks the suggested location dropdown  we should update the our filter location
    setSelectedFilter((prev) => ({
      ...prev,
      search: value,
    }));
    setSelectedOption(false);
  };

  const location = useLocation();
  useEffect(() => {
    setIsBuyModulePage(location.pathname.startsWith("/buy"));
  }, [location.pathname]);

  const options = [
    { label: "Rent", path: "/" },
    { label: "Buy", path: "/buy" },
    { label: "Sell", path: "/sell" },
  ];

  const getActiveClass = (path) => {
    // Handles root route + subpaths
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <section className={`new-banner ${classname} rent-banner`}>
        {/* <div className="banner-element">
          <img src={bannerElement} alt="" />
        </div> */}
        <div className="container">
          <div className="row">
            <div className="col-12 col-xl-10 col-xxl-8 mx-auto">
              <div className="banner-wrap">
                <div className="heading-content">
                  {heading ? (
                    <h1>{heading}</h1>
                  ) : (
                    <h1>
                      Your property RENT, BUY, SELL{" "}
                      <span className="pink-texs">Starts Here</span>
                    </h1>
                  )}
                  <p>{subheading}</p>
                </div>
                <div className="search-options">
                  <div className="search-option-wrap">
                    {options.map(({ label, path }) => (
                      <div
                        key={path}
                        className={`option-item ${
                          getActiveClass(path) ? "active" : ""
                        }`}
                      >
                        <Link to={path}>{label}</Link>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="banner-search">
                  <div className="search-box">
                    <div className="city-input">
                      {!isBuyModulePage && (
                        <Form.Select
                          className="select"
                          name="propertyType"
                          value={formValues.propertyType}
                          onChange={(e) => {
                            setFormValues({
                              ...formValues,
                              propertyType: e.target.value,
                            });
                          }}
                        >
                          <option value={0}>Property Type</option>
                          {bhkError ? (
                            <option>{bhkError}</option>
                          ) : (
                            bhkTypes.map((bhk, index) => (
                              <option key={index} value={bhk.bhkType}>
                                {bhk.bhkType}
                              </option>
                            ))
                          )}
                        </Form.Select>
                      )}
                      {isBuyModulePage && (
                        <PropertyTypeSelect
                          seletedFilter={seletedFilter}
                          buyFilterUpdate={buyFilterUpdate}
                        />
                      )}
                    </div>
                    <div className="banner-property-grid search-input">
                      <PopertyLocationSearch
                        value={formValues.location}
                        onChange={handleInputChange}
                        handleSubmitAfterSuggestionClick={handleSuggestionClick}
                        locations={locationError ? locationError : locations}
                      />
                      {errors.location && (
                        <p className="error-text">{errors.location}</p>
                      )}
                    </div>
                    <div className="search-btn-wrap">
                      <button
                        onClick={handleSubmit}
                        className="search-btn btn btn-primary"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                  {isAnyfilterSet() && isBuyModulePage && (
                    <div className="applied-filter-blocks">
                      <ul className="d-flex flex-wrap mx-auto">
                        {seletedFilterArray.map(
                          (item) =>
                            item.value &&
                            item.key !== "search" && (
                              <li key={item.key}>
                                {item.value}
                                <span className="cursor-pointer">
                                  <FontAwesomeIcon
                                    icon={faClose}
                                    className="clear-filter-btn fs-14"
                                    onClick={() =>
                                      clearSelectedfilters(item.key, item.value)
                                    }
                                  />
                                </span>
                              </li>
                            ),
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
